import 'dotenv/config';
import { capitalize } from 'lodash';

const env = {
  REACT_APP_ENVIRONMENT: checkEnvVar('REACT_APP_ENVIRONMENT'),
  REACT_APP_BUILD_ENV: checkEnvVar('REACT_APP_BUILD_ENV'),
  REACT_APP_TUTORD_API_ORIGIN: checkEnvVar('REACT_APP_TUTORD_API_ORIGIN'),
  REACT_APP_STRIPE_PUBLISHABLE_KEY: checkEnvVar('REACT_APP_STRIPE_PUBLISHABLE_KEY'),
  REACT_APP_GA_ID: checkEnvVar('REACT_APP_GA_ID'),
  REACT_APP_TERMLY_TCP_UUID: checkEnvVar('REACT_APP_TERMLY_TCP_UUID'),
  REACT_APP_TERMLY_PP_UUID: checkEnvVar('REACT_APP_TERMLY_PP_UUID'),
  REACT_APP_TERMLY_AUP_UUID: checkEnvVar('REACT_APP_TERMLY_AUP_UUID'),
  REACT_APP_TERMLY_CP_UUID: checkEnvVar('REACT_APP_TERMLY_CP_UUID'),
  REACT_APP_TERMLY_LUPSI_UUID: checkEnvVar('REACT_APP_TERMLY_LUPSI_UUID')
};

if (env.REACT_APP_ENVIRONMENT === 'sandbox' || env.REACT_APP_ENVIRONMENT === 'development') {
  env.REACT_APP_CODEBUILD_BUILD_NUMBER = checkEnvVar('REACT_APP_CODEBUILD_BUILD_NUMBER');
  env.REACT_APP_GIT_TAG = checkEnvVar('REACT_APP_GIT_TAG');

  console.log(`${capitalize(env.REACT_APP_ENVIRONMENT)} environment so configuring additional build outputs, `);
  console.log('Build Info:');
  console.log(`Environment: ${env.REACT_APP_ENVIRONMENT}`);
  console.log(`REACT_APP_GIT_TAG: ${env.REACT_APP_GIT_TAG}`);
  console.log(`REACT_APP_CODEBUILD_BUILD_NUMBER: ${env.REACT_APP_CODEBUILD_BUILD_NUMBER}`);
}

function checkEnvVar (name) {
  if (!process.env[name]) {
    console.error(`Error: ${name} is not set`);
    throw new Error(`ERROR: Environment variable not specified ${name}`);
  }

  return process.env[name];
}

export default env;
